module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_freienbach-c8b65c99e8d1f37223f6ec2abb3907d3.png";